// extracted by mini-css-extract-plugin
export default {"newsletterInput":"newsletterInput_newsletterInput__iJbPr","buttonAction":"newsletterInput_buttonAction__4lQgr"};